import { withVersions } from "v2/hocs/withVersions";
import { SendTokenDrawer as SendTokenDrawerV1 } from "./SendTokenDrawer/v1";
import { SendTokenDrawer as SendTokenDrawerV2 } from "./SendTokenDrawer/v2";
import { withSendTokenDrawer } from "../hocs/withSendTokenDrawer";

const SendTokenDrawer = withVersions({
  v1: withSendTokenDrawer(SendTokenDrawerV1),
  v2: withSendTokenDrawer(SendTokenDrawerV2),
});

export { SendTokenDrawer };
